<template>
  <list-item v-if="user" class="user-card-wrap">
    <template v-slot:avatar>
      <user-avatar :user="user" :factor="2.75"></user-avatar>
    </template>
    <template v-slot:content>
      <div class="uc-item-name">
        <router-link :to="{ name: 'Profile', params: { id: user.id }}">
          {{ `${user.surName} ${user.name}` }}
        </router-link>
          <el-dropdown v-if="isFriend(user.id)"
            popper-class="uc-item-dropdown"
          >
            <div class="uc-item-menu">
              <i class="fas fa-ellipsis-h"></i>
            </div>
            <template #dropdown>
              <el-dropdown-menu v-if="isFriend(user.id)">
                <el-dropdown-item @click="deleteFriend(user.id)">{{$t('friends.removeFromFriends')}}</el-dropdown-item>
                <el-dropdown-item>{{$t('friends.addToBlackList')}}</el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu v-else-if="isFriendshipRequested(user.id)">
                <el-dropdown-item @click="acceptFriendship(user.id)">{{$t('common.accept')}}</el-dropdown-item>
                <el-dropdown-item @click="denyFriendship(user.id)">{{$t('common.refuse')}}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
      </div>
      <div class="uc-item-info">
        {{
          `${getAge(user.birthdayDay, user.birthdayMonth, user.birthdayYear)} ${user.city && user.city.name !== null ? ', ' + user.city.name : ''}`
        }}
        <span
            class="uc-item-friends"
            @click="openCommonFriendsDialog(user)"
        >{{ getCommonFriendsCount(user) }}
        </span>
      </div>
      <div style="display: flex; justify-content: start;margin-top: 5px;">
        <ButtonTemplate v-if="isOfferedFriendship(user.id)" @click="cancelFriendshipOffer(user.id)">{{$t('common.requestSent')}}</ButtonTemplate>
        <ButtonTemplate
            v-else-if="!isFriend(user.id) && !isFriendshipRequested(user.id)"
            @action="offerFriendship(user.id)"
            style="margin-left: 0;"
        >
          <span class="user-card-button">
            {{$t('friends.addFriends')}}
          </span>
        </ButtonTemplate>

        <!--:backgroundColor="`#006EFF;`"
        :color="`white`"-->
        <ButtonTemplate v-if="typePage !== 'requests'" @action="openConversation">{{$t('common.sendMessage')}}</ButtonTemplate>
        <ButtonTemplate v-if="typePage !== 'requests'" @action="openConversation">{{$t('common.call')}}</ButtonTemplate>
        <ButtonTemplate v-if="typePage === 'requests'" @click="accept">{{$t('common.accept')}}</ButtonTemplate>
        <ButtonTemplate v-if="typePage === 'requests'" @click="denyFriendship(user.id)">{{$t('common.refuse')}}</ButtonTemplate>
      </div>
    </template>
  </list-item>

  <user-grid-dialog
      v-if="commonFriendsDialog"
      :users="commonFriends"
      :title="$t('friends.mutualFriends')"
      @closed="commonFriendsDialog = false"
  ></user-grid-dialog>

</template>

<script>
import UserAvatar from "@/components/avatars/UserAvatar";
import ListItem from "@/components/Common/ListItem";
import UserGridDialog from './UserGridDialog';
import relationshipMixins from "@/mixins/relationship-mixins";
import { mapGetters, mapState } from 'vuex';
import ButtonTemplate from "../Post/button/ButtonTemplate";

export default {
  props: {
    user: Object,
    typePage: String
  },
  emits: ['removeUserFromList'],
  mixins: [relationshipMixins],
  components: {
    ButtonTemplate,
    "list-item": ListItem,
    "user-avatar": UserAvatar,
    "user-grid-dialog": UserGridDialog
  },
  data() {
    return {
      commonFriendsDialog: false,
      commonFriends: []
    }
  },
  computed: {
    ...mapGetters("context", ["currentUserId"]),
    ...mapState('cache', ['chats'])
  },
  methods: {
    accept(){
      this.acceptFriendship(this.user.id)
      this.$emit('removeUserFromList', this.user.id);
    },
    deny(){
      this.denyFriendship(this.user.id);
      this.$emit('removeUserFromList', this.user.id);
    },
    openConversation() {
      this.$router.push({ name: "Conversation", query: { userId: this.user.id } });
    },
    openCommonFriendsDialog(user) {
      this.commonFriends = this.getCommonFriends(user);
      if (this.commonFriends && this.commonFriends.length > 0) {
        this.commonFriendsDialog = true;
      }
    }
  }
}
</script>

<style lang="scss">
.g-list-item {
  border: none;
  border-top: 1px solid var(--line);
  border-radius: 0;
  padding: 20px 15px;
  margin-bottom: 0;
}
.uc-item-dropdown{
  background: var(--user-card-dropdown-background);
  box-shadow: 0 4px 24px rgb(0 110 255 / 50%);
  border-radius: 5px;
}
.uc-item-dropdown .el-scrollbar__view{
  padding: 0;
  margin: 0;
}
.user-card-button {
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--post-show-next-text);
}
.user-card-wrap .uc-item-name {
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--user-card-text);
  display: flex;
  justify-content: space-between;
}

.user-card-wrap .uc-item-name a {
  text-decoration: none;
  color: var(--user-card-text);
}
.user-card-wrap .uc-item-name a:visited{
  color: var(--user-card-text);
}
.user-card-wrap .uc-item-name a:hover {
  text-decoration: underline;
}

.user-card-wrap .uc-item-info {
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--user-card-info-text);
  margin-top: 10px;
}

.user-card-wrap .uc-item-friends {
  color: var(--user-card-common-friend-text);
  font-size: .9em;
  cursor: pointer;
}

.user-card-wrap .uc-item-friends:hover {
  text-decoration: underline;
}

.user-card-wrap .uc-item-menu {
  display: flex;
  align-items: center;
  border: none;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  color: var(--three-dots);
  cursor: pointer;
}

.user-card-wrap .uc-aside-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
}
</style>
